var s = Object.defineProperty;
var m = (a, o, t) => o in a ? s(a, o, { enumerable: !0, configurable: !0, writable: !0, value: t }) : a[o] = t;
var e = (a, o, t) => m(a, typeof o != "symbol" ? o + "" : o, t);
import { BaseEnvironment as i } from "./main6.js";
class n extends i {
  constructor() {
    super(...arguments);
    /**
     * Webmotors base domain
     *
     */
    e(this, "domain", "hportal.webmotors.com.br");
    /**
     * Enable logging for HML Environment
     *
     */
    e(this, "logging", !0);
    /**
     * Webmotors api URL
     *
     */
    e(this, "apiURL", `https://${this.domain}/api`);
    /**
     * Webmotors private api URL
     *
     */
    e(this, "apiPrivateURL", "https://yur5i9svf7-vpce-0f91c6824aa2e651d.execute-api.us-east-1.amazonaws.com/hml/api");
    /**
     * SEO private api URL
     *
     */
    e(this, "seoApiPrivateURL", "https://sem3hlobfi-vpce-0f91c6824aa2e651d.execute-api.us-east-1.amazonaws.com/hml/api");
    /**
     * Webmotors base URL
     *
     */
    e(this, "baseURL", `https://${this.domain}`);
    /**
     * Cookie domain on HML environment
     *
     */
    e(this, "cookieDomain", [this.domain, `.${this.domain}`, ".webmotors.com.br"]);
    /**
     * Auth Cookie Name on staging environment
     *
     */
    e(this, "authCookieName", "webmotors.jwt.token.hk");
    /**
     * Access Token Cookie Name on staging environment
     *
     */
    e(this, "accessTokenCookieName", "webmotors.access.token");
    /**
     * Refresh Token Cookie Name on staging environment
     *
     */
    e(this, "refreshTokenCookieName", "webmotors.refresh.token.hk");
    /**
     * Vehicle photo path on HML environment
     *
     */
    e(this, "photoPath", "https://himage.webmotors.com.br");
    /**
     * Webmotors chat api websocket URL
     *
     */
    e(this, "chatApiUrl", "wss://hchat.webmotors.com.br");
    /**
     * Hot deal image path on HML environment
     *
     */
    e(this, "hotDealImage", "https://image.webmotors.com.br/feiroes/imagens/hml/_portal/");
    /**
     * Data Dog Sample Config
     */
    e(this, "traceSampleRate", 100);
    e(this, "sessionSampleRate", 10);
    e(this, "sessionReplaySampleRate", 10);
    /**
     * Seller shield image path
     */
    e(this, "sellerShieldImage", "https://s3.amazonaws.com/webmotors/blindagem-fotos/hml/");
    /**
     * Login route
     *
     */
    e(this, "loginRoute", `https://${this.domain}/login`);
  }
}
export {
  n as HmlEnvironment
};
